import merge from 'lodash-es/merge.js';

var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _config, _FetchHelper_instances, handleResponse_fn, transformUrl_fn;
class FetchHelper {
  constructor(config = {}) {
    __privateAdd(this, _FetchHelper_instances);
    __privateAdd(this, _config, {});
    __privateSet(this, _config, config);
  }
  async request(url, options) {
    const _options = merge({}, __privateGet(this, _config), options);
    const interceptedOptions = await __privateGet(this, _config).requestInterceptor?.(_options);
    const { suppressConsoleErrors, baseUrl, timeout, responseInterceptor, ...requestOptions } = merge({}, _options, interceptedOptions);
    const requestUrl = __privateMethod(this, _FetchHelper_instances, transformUrl_fn).call(this, url, baseUrl);
    return fetch(requestUrl, {
      signal: timeout ? AbortSignal.timeout(timeout) : void 0,
      ...requestOptions
    }).then((response) => __privateMethod(this, _FetchHelper_instances, handleResponse_fn).call(this, response, {
      suppressConsoleErrors,
      responseInterceptor
    }));
  }
  async get(url, options = {}) {
    return this.request(url, options);
  }
  async post(url, body, options = {}) {
    return this.request(url, {
      ...options,
      method: "POST",
      body: JSON.stringify(body)
    });
  }
  async put(url, body, options = {}) {
    return this.request(url, {
      ...options,
      method: "PUT",
      body: JSON.stringify(body)
    });
  }
  async patch(url, body, options) {
    return this.request(url, {
      ...options,
      method: "PATCH",
      body: JSON.stringify(body)
    });
  }
  async delete(url, options) {
    return this.request(url, {
      ...options,
      method: "DELETE"
    });
  }
}
_config = new WeakMap();
_FetchHelper_instances = new WeakSet();
handleResponse_fn = async function(response, options = {}) {
  if (options.responseInterceptor) {
    return options.responseInterceptor(response);
  }
  if (response.ok) {
    return {
      arrayBuffer: response.arrayBuffer.bind(response),
      blob: response.blob.bind(response),
      body: response.body,
      bodyUsed: response.bodyUsed,
      clone: response.clone,
      data: await response.json(),
      formData: response.formData,
      headers: response.headers,
      json: response.json,
      ok: response.ok,
      redirected: response.redirected,
      status: response.status,
      statusText: response.statusText,
      text: response.text,
      type: response.type,
      url: response.url
    };
  }
  if (!options.suppressConsoleErrors) {
    const message = options.formatConsoleError?.(response) ?? `${response.status} ${response.statusText}`;
    console.error(message);
  }
  throw response;
};
transformUrl_fn = function(url, baseUrl) {
  if (baseUrl) {
    if (baseUrl.startsWith("http://") || baseUrl.startsWith("https://")) {
      return new URL(url, baseUrl).toString();
    }
    return `${baseUrl.replace(/\/$/, "")}/${url.replace(/^\//, "")}`;
  }
  return url;
};

export { FetchHelper as default };
//# sourceMappingURL=index.mjs.map
